import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import AddIcon from "@mui/icons-material/Add";

export default function DocTransmittalDataForm({ values, dataGrid, formName }) {
  const {
    allDocTransmittals,
    newDoc,
    setNewDoc,
    handleOpenDocTransmittalRegister,
  } = useDocTransmittalContext();

  const onChange = (e) => {
    const { name, value } = e.target;
    console.log({ name, value }, allDocTransmittals);
    if (formName) {
      name === "number"
        ? setNewDoc({ ...allDocTransmittals.find((d) => d.number === value) })
        : setNewDoc({
            ...newDoc,
            [formName]: { ...newDoc[formName], [name]: value },
          });
    } else {
      name === "number"
        ? setNewDoc({
            ...newDoc,

            ...allDocTransmittals.find((d) => d.number === value),
          })
        : setNewDoc({ ...newDoc, [name]: value });
    }
  };

  return (
    <Grid container spacing={2} columns={{ xs: 6.8 }}>
      {dataGrid.map((item, index) => (
        <React.Fragment key={index}>
          <Grid item xs={item.grid}>
            <Typography>{item.label}:</Typography>
          </Grid>
          <Grid item xs={["number", "purpose"].includes(item.field) ? 2.8 : 2}>
            {item.options ? (
              ["number"].includes(item.field) ? (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Select
                    value={values[item.field]}
                    onChange={onChange}
                    name={item.field}
                    fullWidth
                    sx={{
                      "& .MuiSelect-select": {
                        p: 0.5,
                      },
                    }}
                  >
                    {allDocTransmittals.map((opt) => {
                      return (
                        <MenuItem value={opt.number} key={opt.number}>
                          {opt.number}
                        </MenuItem>
                      );
                    })}
                  </Select>

                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenDocTransmittalRegister}
                  >
                    Add
                  </Button>
                </Box>
              ) : (
                <Select
                  value={values[item.field]}
                  onChange={onChange}
                  fullWidth
                  name={item.field}
                  sx={{
                    "& .MuiSelect-select": {
                      p: 0.5,
                    },
                  }}
                >
                  {item?.options.map((opt) => {
                    return (
                      <MenuItem value={opt} key={opt}>
                        {opt}
                      </MenuItem>
                    );
                  })}
                </Select>
              )
            ) : (
              <TextField
                variant="outlined"
                value={values[item.field]}
                name={item.field}
                onChange={onChange}
                hiddenLabel
                size="small"
                disabled={[
                  "Project Name",
                  "Project Type",
                  "Project Rev",
                ].includes(item.label)}
                fullWidth={["rev"].includes(item.field) ? false : true}
                inputProps={{ sx: { padding: "2px", pl: "5px" } }}
              />
            )}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}
